import BorrowerMailboxContent from './borrower-mailbox-content';

export default BorrowerMailboxContent;
